<template>
    
</template>

<script>
export default {
    created() {
        _MEIQIA('showPanel');
    }
}
</script>


// WEBPACK FOOTER //
// src/components/customer.vue